module.exports = __webpack_public_path__ + "static/media/image-garante.1070ad75.png";